import { ArrowRightIcon, MapPinIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";

import dubaiSkyline from "../assests/images/dubai-skyline.webp";

export default function ExploreDubai() {
    const navigate = useNavigate();

    const experiences = [
        {
            title: "Burj Khalifa",
            image:
                "https://images.unsplash.com/photo-1518684079-3c830dcef090?auto=format&fit=crop&w=800&q=80",
        },
        {
            title: "Dubai Marina",
            image:
                "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=800&q=80",
        },
        {
            title: "Dubai Mall",
            image:
                "https://images.unsplash.com/photo-1580674684081-7617fbf3d745?auto=format&fit=crop&w=800&q=80",
        },
        {
            title: "Desert Safari",
            image:
                "https://images.unsplash.com/photo-1546412414-e1885259563a?auto=format&fit=crop&w=800&q=80",
        },
    ];

    return (
        <section className="w-full bg-white py-10 sm:py-12 lg:py-14">
            <div className="mx-auto  max-w-[1536px]
              px-4
            sm:px-6
            lg:px-8">

                <div
                    className="
                        group
                        relative
                        overflow-hidden
                        rounded-2xl
                        border
                        border-[#0B6E8E]/20
                        bg-[#062F4F]
                        shadow-[0_12px_35px_rgba(6,47,79,0.12)]
                    "
                >

                    {/* Decorative background */}
                    <div
                        className="
                            pointer-events-none
                            absolute
                            -left-24
                            -top-24
                            h-64
                            w-64
                            rounded-full
                            border-[35px]
                            border-[#F7B928]/[0.06]
                        "
                    />

                    <div
                        className="
                            pointer-events-none
                            absolute
                            -bottom-32
                            left-[30%]
                            h-72
                            w-72
                            rounded-full
                            border-[40px]
                            border-white/[0.03]
                        "
                    />

                    <div
                        className="
                            relative
                            grid
                            lg:grid-cols-[0.9fr_1fr_1.25fr]
                        "
                    >

                        {/* =================================
                            LEFT IMAGE
                        ================================== */}
                        <div className="relative min-h-[260px] overflow-hidden lg:min-h-[310px]">

                            <img
                                src={dubaiSkyline}
                                alt="Dubai skyline"
                                className="
                                    absolute
                                    inset-0
                                    h-full
                                    w-full
                                    object-cover
                                    object-center
                                    transition-transform
                                    duration-700
                                    group-hover:scale-105
                                "
                            />

                            {/* Image overlay */}
                            <div
                                className="
                                    absolute
                                    inset-0
                                    bg-gradient-to-r
                                    from-transparent
                                    via-[#062F4F]/10
                                    to-[#062F4F]/95
                                "
                            />

                            <div
                                className="
                                    absolute
                                    inset-0
                                    bg-gradient-to-t
                                    from-[#062F4F]/45
                                    via-transparent
                                    to-transparent
                                "
                            />

                            {/* Image label */}
                            <div className="absolute bottom-5 left-5">

                                <div
                                    className="
                                        inline-flex
                                        items-center
                                        gap-2
                                        rounded-full
                                        border
                                        border-white/20
                                        bg-[#062F4F]/55
                                        px-3
                                        py-1.5
                                        backdrop-blur-md
                                    "
                                >
                                    <MapPinIcon className="h-3.5 w-3.5 text-[#F7B928]" />

                                    <span className="text-[10px] font-bold uppercase tracking-[0.15em] text-white">
                                        Dubai, UAE
                                    </span>
                                </div>

                            </div>
                        </div>


                        {/* =================================
                            CENTER CONTENT
                        ================================== */}
                        <div
                            className="
                                relative
                                flex
                                flex-col
                                justify-center
                                px-6
                                py-8
                                sm:px-8
                                lg:px-8
                                    xl:px-10
                            "
                        >

                            <div className="relative z-10">

                                {/* Eyebrow */}
                                <div className="mb-3 flex items-center gap-2.5">

                                    <span className="h-[2px] w-7 bg-[#F7B928]" />

                                    <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#F7B928]">
                                        Explore Dubai
                                    </span>

                                </div>


                                {/* Heading */}
                                <h2
                                    className="
                                        text-2xl
                                        font-extrabold
                                        leading-tight
                                        tracking-tight
                                        !text-white
                                        sm:text-3xl
                                    "
                                >
                                    More Than Just a Stay
                                    <span className="block text-[#F7B928]">
                                        — It's an Experience
                                    </span>
                                </h2>


                                {/* Description */}
                                <p
                                    className="
                                        mt-3
                                        max-w-md
                                        text-xs
                                        leading-6
                                        text-white/65
                                        sm:text-sm
                                    "
                                >
                                    From iconic landmarks to world-class
                                    shopping, Dubai has it all. Book your
                                    hotel and explore the best of the city
                                    with local tips and guides.
                                </p>


                                {/* CTA */}
                                <button
                                    type="button"
                                    onClick={() => navigate("/services")}
                                    className="
                                        mt-5
                                        inline-flex
                                        items-center
                                        gap-2
                                        rounded-xl
                                        bg-[#F7B928]
                                        px-5
                                        py-3
                                        text-xs
                                        font-extrabold
                                        text-[#062F4F]
                                        shadow-[0_8px_20px_rgba(247,185,40,0.18)]
                                        transition-all
                                        duration-300
                                        hover:bg-[#FF5A1F]
                                        hover:text-white
                                        hover:shadow-[0_10px_25px_rgba(255,90,31,0.25)]
                                        active:scale-[0.98]
                                    "
                                >
                                    <span>Explore Dubai Guide</span>

                                    <ArrowRightIcon
                                        className="
                                            h-4
                                            w-4
                                            transition-transform
                                            duration-300
                                            group-hover:translate-x-1
                                        "
                                    />
                                </button>

                            </div>
                        </div>


                        {/* =================================
                            EXPERIENCE GRID
                        ================================== */}
                        <div className="grid grid-cols-2 gap-2.5 p-3 sm:gap-3 sm:p-4">

                            {experiences.map((experience) => (
                                <div
                                    key={experience.title}
                                    className="
                                        group/card
                                        relative
                                        min-h-[125px]
                                        overflow-hidden
                                        rounded-xl
                                        border
                                        border-white/20
                                        bg-white/10
                                        cursor-pointer
                                    "
                                    onClick={() => navigate("/services")}
                                >

                                    <img
                                        src={experience.image}
                                        alt={experience.title}
                                        className="
                                            absolute
                                            inset-0
                                            h-full
                                            w-full
                                            object-cover
                                            transition-transform
                                            duration-500
                                            group-hover/card:scale-110
                                        "
                                    />

                                    {/* Card overlay */}
                                    <div
                                        className="
                                            absolute
                                            inset-0
                                            bg-gradient-to-t
                                            from-[#062F4F]/90
                                            via-[#062F4F]/20
                                            to-transparent
                                        "
                                    />

                                    {/* Card title */}
                                    <div className="absolute bottom-3 left-3 right-3">

                                        <div className="flex items-center justify-between gap-2">

                                            <span
                                                className="
                                                    text-xs
                                                    font-bold
                                                    text-white
                                                    sm:text-sm
                                                "
                                            >
                                                {experience.title}
                                            </span>

                                            <ArrowRightIcon
                                                className="
                                                    h-3.5
                                                    w-3.5
                                                    shrink-0
                                                    text-[#F7B928]
                                                    opacity-0
                                                    -translate-x-1
                                                    transition-all
                                                    duration-300
                                                    group-hover/card:translate-x-0
                                                    group-hover/card:opacity-100
                                                "
                                            />

                                        </div>

                                    </div>

                                </div>
                            ))}

                        </div>

                    </div>
                </div>

            </div>
        </section>
    );
}